// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"31035d47","487":"79d5e2d5"}[chunkId] + ".chunk.js";
};